import Dropdown from "@/components/ui/dropdown";
import { DataSettings } from "@/types/dataSetting";

import { SINGLE_GEOMETRY_OPTIONS } from "./dataSettingOptions";

interface SingleTypeProps {
  dataSetting: DataSettings | null;
  handleSpatialAggregationSelect: <
    K extends keyof NonNullable<DataSettings["spatialAggregation"]>
  >(
    key: K,
    value: NonNullable<DataSettings["spatialAggregation"]>[K]
  ) => void;
}

const SingleGeometrySetting = ({
  dataSetting,
  handleSpatialAggregationSelect
}: SingleTypeProps) => {
  return (
    <div className="flex flex-col">
      <Dropdown
        className="mt-4"
        placeholder="Spatial Aggregation*"
        data={SINGLE_GEOMETRY_OPTIONS}
        value={dataSetting?.spatialAggregation?.type}
        disabled
        onSelect={(data) => {
          if (!data) return;
          handleSpatialAggregationSelect("type", data);
        }}
      />
      <span className="text-xs mt-4">
        Spatial Aggregation has been selected automatically by the system.
      </span>
    </div>
  );
};

export default SingleGeometrySetting;
